import React from 'react';
import { useParams } from 'react-router-dom';
import { Text, Card, useResponsiveParams } from 'quanta-ui';
import ViewProposalDetailsHealth from './view-proposal-health-SCPA';
import ViewProposalDetailsCarSecure from './view-proposal-car-secure';
import ViewProposalDetailsGCV from './view-proposal-GCV';
import ViewProposalDetailsPCV from './view-proposal-PCV';
import ViewProposalDetailsMISCD from './view-proposal-MISCD';
//import { ClientService, Layout, Loading } from '../../../lib/layout';
import { ClientService, Layout, Loading } from 'quanta-flows/modules/layout';
import { LOB_PRODUCT_LIST } from './queries';
import { useQuery } from '@apollo/client';

// import ViewProposalDetailsIpa from './view-proposal-ipa';
// import ViewProposalWorkmen from './view-proposal-workmen';
import ViewProposalFire from './view-proposal-fire';

export default function ViewProposalDetails({
  lobCode,
  lobName,
  productCode,
  productName,
  proposalNumber,
}) {
  const params = useParams();
  const customerID = params?.customerID;
  const lob_code = lobCode ? lobCode : params?.lob_code;
  const lob_name = lobName ? lobName : params?.lob_name;
  const product_code = productCode
    ? productCode
    : params?.product_code;
  const product_name = productName
    ? productName
    : params?.product_name;
  const proposal_number = proposalNumber
    ? proposalNumber
    : params?.proposal_number;

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });
  const { loading, error, data } = useQuery(LOB_PRODUCT_LIST, {
    fetchPolicy: 'cache-first',
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error />;
  }

  const { lobProductList } = data;

  if (
    lobProductList?.find(
      (lob) =>
        lob?.lob_code?.toLowerCase() === lob_code?.toLowerCase() &&
        lob?.lob_name?.toLowerCase() === lob_name?.toLowerCase(),
    ) &&
    lobProductList
      ?.find(
        (lob) =>
          lob?.lob_code?.toLowerCase() === lob_code?.toLowerCase() &&
          lob?.lob_name?.toLowerCase() === lob_name?.toLowerCase(),
      )
      ?.products?.find(
        (product) =>
          product?.product_code?.toLowerCase() ===
            product_code?.toLowerCase() &&
          product?.product_name?.toLowerCase() ===
            product_name?.toLowerCase(),
      )
  ) {
    if(product_code?.toString()==='3153')
    {
      return (
        <ViewProposalDetailsHealth
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    }
    else if (
      lob_name?.toString()?.trim()?.toLowerCase()?.search('motor') !==
      -1 && (product_code?.toString()==='3137' || product_code?.toString()==='3140')
    ) {
      return (
        <ViewProposalDetailsGCV
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    } 
    else if (
      lob_name?.toString()?.trim()?.toLowerCase()?.search('motor') !==
      -1 && (product_code?.toString()==='3183' || product_code?.toString()==='3184')
    ) {
      return (
        <ViewProposalDetailsPCV
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    }
    else if (
      lob_name?.toString()?.trim()?.toLowerCase()?.search('motor') !==
      -1 && (product_code?.toString()==='3128' || product_code?.toString()==='3129')
    ) {
      return (
        <ViewProposalDetailsMISCD
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    }
    else if (
      lob_name?.toString()?.trim()?.toLowerCase()?.search('motor') !==
      -1 && (product_code?.toString()==='3121' || product_code?.toString()==='3151'
       || product_code?.toString()==='3176')
    ) {
      return (
        <ViewProposalDetailsCarSecure
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    } else if (
      lob_name
        ?.toString()
        ?.trim()
        ?.toLowerCase()
        ?.search('health') !== -1
    ) {
      return (
        <ViewProposalDetailsHealth
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    } else if (
      lob_name?.toString()?.trim()?.toLowerCase()?.search('fire') !==
      -1
    ) {
      return (
        <ViewProposalFire
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    } else if (
      lob_name
        ?.toString()
        ?.trim()
        ?.toLowerCase()
        ?.search('personal accident') !== -1
    ) {
      return (
        <ViewProposalDetailsIpa
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    } else if (
      lob_name
        ?.toString()
        ?.trim()
        ?.toLowerCase()
        ?.search('miscellaneous') !== -1
    ) {
      return (
        <ViewProposalWorkmen
          customerID={customerID}
          lobCode={lob_code}
          lobName={lob_name}
          productName={product_name}
          productCode={product_code}
          proposalNumber={proposal_number}
        />
      );
    } else {
      return (
        <Layout
          nav={['Proposal', 'View Proposal']}
          service_type={ClientService}
        >
          <Card className="h-screen" severity={`error`}>
            <Text
              severity={'error'}
              className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
            >
              Given Lob is not Available or Invalid
            </Text>
          </Card>
        </Layout>
      );
    }
  } else {
    return (
      <Layout
        nav={['Proposal', 'View Proposal']}
        service_type={ClientService}
      >
        <Card className="h-screen" severity={`error`}>
          <Text
            severity={'error'}
            className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
          >
            Given Lob/Product Information is not Available or Invalid
          </Text>
        </Card>
      </Layout>
    );
  }
}
